import * as ko from "knockout";
import * as moment from "moment";
import labels from "./labels";

export const DISPLAY_DATE_DEFAULT_FORMAT = "DD/MM/YYYY";
export const DISPLAY_DATETIME_DEFAULT_FORMAT = "DD/MM/YYYY HH:mm";

export const DISPLAY_DATE_NEW_DEFAULT_FORMAT = "dd/MM/yyyy";
export const DISPLAY_DATETIME_NEW_DEFAULT_FORMAT = "dd/MM/yyyy HH:mm";

export namespace CustomObservables {
  //

  export const formattedDateTimeObservable = (underlying, no_date_label: string = null): KnockoutComputed<string> => {
    return ko.pureComputed({
      read: function () {
        if (underlying() && underlying().toString() != "Invalid Date") {
          return moment(underlying()).format(DISPLAY_DATETIME_DEFAULT_FORMAT);
        }
        return labels.descr(no_date_label || "");
      },
      write: function (value) {
        if (value == "") {
          underlying(null);
        } else {
          var dt = moment(value, DISPLAY_DATETIME_DEFAULT_FORMAT);
          underlying(dt);
        }
      },
      deferEvaluation: true,
    });
  };
  export const formattedDateObservable = (underlying, no_date_label: string = null): KnockoutComputed<string> => {
    return ko.pureComputed({
      read: function () {
        if (underlying() && underlying().toString() != "Invalid Date") {
          return moment(underlying()).format(DISPLAY_DATE_DEFAULT_FORMAT);
        }
        return labels.descr(no_date_label || "");
      },
      write: function (value) {
        if (value == "") underlying(null);
        else {
          var dt = moment(value, DISPLAY_DATE_DEFAULT_FORMAT);
          underlying(dt);
        }
      },
      deferEvaluation: true,
    });
  };

  export function getFirstValErrMsg(propertyName) {
    var errs = this.entityAspect.getValidationErrors(propertyName);
    return errs.length ? errs[0].errorMessage : "";
  }

  export function hasValidationErrorsObservable(entity) {
    var prop = ko.observable(false);
    var onChange = function () {
      var hasError = entity.entityAspect.getValidationErrors().length > 0;
      if (prop() === hasError) {
        prop.valueHasMutated();
      } else {
        prop(hasError);
      }
    };

    onChange();
    entity.entityAspect.validationErrorsChanged.subscribe(onChange);
    return prop;
  }
}
